module.exports = __webpack_public_path__ + "static/media/carta_67.e7f6825c.jpg";